import { fetch } from 'owa-fetch';
//We are using this to get the bookingMailbox in format {mailboxId}@{tenantId}

const regex = /([^\/]+)\/openid/;

export async function getTenantId(bookingMailbox: string) {
    const _bookingMailbox =
        bookingMailbox.indexOf('@') > -1 ? bookingMailbox.split('@') : bookingMailbox.split('%40');

    const mailboxId = _bookingMailbox[0];

    //TODO: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/213008

    //API to fetch tenant domain
    const rootHtml = await fetch(
        `https://login.microsoftonline.com/${_bookingMailbox[1]}/.well-known/openid-configuration`
    );

    const res = await rootHtml.json();
    const domain = res.userinfo_endpoint.match(regex);
    return `${mailboxId}@${domain[1]}`; //{mailboxId}@{tenantId}
}
